const t = "0x0000000000000000000000000000000000000000", e = "0x0000000000000000000000000000000000000000000000000000000000000000", o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NULL_ADDRESS: t,
  NULL_BYTES32: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  t as N,
  e as a,
  o as c
};
